import { useState, useEffect, useContext, useRef } from 'react';

import { LiveReserveContext } from '../../../LiveLessonReseveContext';
import LiveReserveDateModalDate from './date/LiveReserveDateModalDate';
import LiveReserveDateModalFree from './free/LiveReserveDateModalFree';


/**
 * 日程の選択 (SPEAKOUT-1853 で2モードになった)
 *
 * - 空き枠がある … 従来どおり枠の一覧。下の「他の日時をリクエストする」で希望日時の入力へ
 * - 空き枠が1つも無い … 開いた時点で希望日時の入力（戻り先が無いので一覧は出さない）
 *
 * ★どちらのモードかは Context の isRequestMode が持つ。ここでは「モーダルを開いている間の
 *   切り替え」だけをローカルに持ち、決定（枠のタップ / 日時の決定）で親の状態を確定させる。
 */
function LiveReserveDateModal(props: any) {

  const {
    calendar, chkCal,
    isLesson, isRequestMode, setIsRequestSelected,
  } = useContext(LiveReserveContext);

  const setIsDispModal = props.setIsDispModal;

  // 時間一覧表示の日付(他は閉じる)
  const [openDateKey, setOpenDateKey] = useState<string>('');
  const dateRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});
  // 希望日時の入力を開いているか。開いた時点のモードを引き継ぐ
  const [isFreeInput, setIsFreeInput] = useState<boolean>(isRequestMode);

  // 開いている日付が変わったら一番上になるようスクロール
  useEffect(() => {
    const target = dateRefs.current[openDateKey];
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [openDateKey]);


  // 希望日時の入力へ
  const onClickRequest = () => {
    setIsRequestSelected(true);
    setIsFreeInput(true);
  };

  // 空き枠の一覧へ戻る
  const onBackToSlots = () => {
    setIsRequestSelected(false);
    setIsFreeInput(false);
  };


  if (isFreeInput) {
    return (
      <LiveReserveDateModalFree
        canBackToSlots={isLesson}
        onBackToSlots={onBackToSlots}
        setIsDispModal={setIsDispModal}
      />
    );
  }

  return (
    <>
      {Object.entries(calendar).map(([dateKey, dateInfo]: [string, any]) =>
        chkCal[dateKey] && (
          <>
            {/* 日付一覧 */}
            <LiveReserveDateModalDate
              dateKey={dateKey}
              dateInfo={dateInfo}
              openDateKey={openDateKey}
              setOpenDateKey={setOpenDateKey}
              dateRef={(el: HTMLDivElement | null) => {
                dateRefs.current[dateKey] = el;
              }}
            />
          </>
        )
      )}

      {/* ★SPEAKOUT-1853 「出ている枠が自分の都合に合わない」人のための入口。
          実データ上、講師リクエストの8割は【枠を出している人気講師への別日程の依頼】で、
          その85%が事務局で成立している＝ここを塞いではいけない。 */}
      <div className="text-center" style={{padding: '15px 10px 5px'}}>
        <button
          type="button"
          className="btn btn-info"
          style={{width: '90%', whiteSpace: 'normal'}}
          onClick={onClickRequest}
        >
          他の日時をリクエストする
        </button>
        {/* 🔴 ここに注意書きは置かない。Modal(common/Modal.tsx) の器は透明で、
            このブロックは背景を持たないため【後ろのページが透けて文字が読めない】
            （2026-09-08 実機で確認）。同じ内容はリクエストの入力画面の下部に出しており、
            押した先で必ず読める。 */}
      </div>
    </>
  );
}

export default LiveReserveDateModal;
